import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AllowListUserInputModel } from "../../models/allow-list-user-input.model";
import { AllowListUserModel } from "../../models/allow-list-user.model";
import { PartnerAllowListUserInput } from "../../models/email-allow-list-input.model";
import { PagedResult } from "../../models/page-result.model";
import { OsmosisApiBase } from "../mcap-events/api-base";


@Injectable({
  providedIn: 'root'
})
export class AllowListUserApi extends OsmosisApiBase {
  getPartnerEmailAccessList(
    allowListInput: PartnerAllowListUserInput
  ): Observable<PagedResult<AllowListUserModel>> {
    return this.postContent<PagedResult<AllowListUserModel>>(
      'api/EmailAllowList/GetAllowListUsers',
      allowListInput,
      null
    );
  }

  updatePartnerEmailListStatus(
    userId: number,
    isDeactivate: boolean
  ): Observable<boolean> {
    return this.postContent<boolean>(
      `api/EmailAllowList/ActivateOrDeactivateAllowListUser?allowListUserId=${userId}&isDeactivate=${isDeactivate}`,
      null,
      null
    );
  }

  addUserToAllowList(
    allowListUser: AllowListUserInputModel
  ): Observable<boolean> {
    return this.postContent<boolean>(
      'api/EmailAllowList/AddAllowListUser',
      allowListUser,
      null
    );
  }
}
